module.exports = __webpack_public_path__ + "img/ertiga-boostergreen-glx-gris-magma.80fe8ff2.png";